import {
  Component,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserReviewActions } from '@shared/constants/user-review.enum';
import { ReviewsAnalyticsService } from '@shared/services/reviews/analytics/reviews-analytics.service';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-user-review-modal',
  templateUrl: './user-review-modal.component.html',
  styleUrls: ['./user-review-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserReviewModalComponent {
  @Output() review = new EventEmitter<UserReviewActions>();

  thumbsUpSelected = false;
  thumbsDownSelected = false;

  constructor(
    public translate: TranslateService,
    private reviewsAnalyticsService: ReviewsAnalyticsService,
    private modalCtrl: ModalController,
  ) {}

  thumbsUp() {
    this.thumbsUpSelected = true;
    this.thumbsDownSelected = false;
    this.reviewsAnalyticsService.trackThumbsUp();
    this.review.emit(UserReviewActions.UP);
    this.modalCtrl.dismiss({ review: UserReviewActions.UP });
  }

  thumbsDown() {
    this.thumbsDownSelected = true;
    this.thumbsUpSelected = false;
    this.reviewsAnalyticsService.trackThumbsDown();
    this.review.emit(UserReviewActions.DOWN);
    this.modalCtrl.dismiss({ review: UserReviewActions.DOWN });
  }

  dismiss() {
    this.modalCtrl.dismiss({ review: UserReviewActions.DISMISS });
  }
}
